import { render, staticRenderFns } from "./JobPriceIntro.vue?vue&type=template&id=510c92d1"
import script from "./JobPriceIntro.vue?vue&type=script&lang=js"
export * from "./JobPriceIntro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports